const $ = require('jquery');
const forEach = require('lodash.foreach');

const $buttons = $('.button, .button--secondary').not('input, .delete-order-item');
const $submitButtons = $('input[type="submit"]').not('.delete-order-item');
const avgLetterWidth = 11.75;


// make sure doc is ready, then add button styles
$(document).ready(() => {
  processButtons($buttons, $submitButtons);
});

$(window).on("load", () => {
  updateWidths($submitButtons);
});

$(document).ajaxComplete(() => {
  const $newButtons = $('.button, .button--secondary').not('input, [href$="pdf"], .delete-order-item, .js-processed');
  const $newSubmitButtons = $('input[type="submit"]').not('.delete-order-item, .js-processed');

  processButtons($newButtons, $newSubmitButtons);
});

function processButtons(buttons, inputButtons) {
  // console.log('start process');
  forEach(buttons, item => {
    const btnSize = $(item).outerWidth(true) * 2;
    $(item).addClass('js-processed').wrapInner('<div class="button-inner"></div>').find('.button-inner').after(sizedSVG(btnSize));
  });

  forEach(inputButtons, item => {
    const itemID = $(item).attr('id');
    $(item).addClass('js-processed').wrap(`<div data-child-id="${itemID}" class="button-outer"></div>`);
    // get button size after it's been wrapped
    let btnSize = $(item).outerWidth(true) * 2;
    if ((btnSize / 2) / $(item).val().trim().length < avgLetterWidth) {
      btnSize = avgLetterWidth * $(item).val().trim().length * 2;
    }
    $(item).after(sizedSVG(btnSize));
  });
}

// run after load. Fixes widths in button svgs once all styles are applied
// and fonts are loaded in
function updateWidths(inputButtons) {
  forEach(inputButtons, item => {
    const $svg = $(item).next().find('svg');
    // this may get called before the svg has been added, if so, break out of function
    if ($svg.length === 0) {
      return;
    }

    let btnSize = $(item).outerWidth(true) * 2;

    $svg[0].setAttribute('width', btnSize)
    $svg[0].setAttribute('height', btnSize);
  });
}


// returns an svg that is sized perfectly for each button
// needed for ie compatability
function sizedSVG(size) {
  const svg = `<div class="fill">
                <div class="fill-wave">
                  <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300">
                    <path d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4 c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9 c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"></path>
                  </svg>
                </div>
              </div>`;
  return svg;
}
